// テンプレートごとのアニメーション設定レジストリ
// 新しいテンプレート用の設定を追加するには:
// 1. このディレクトリに新しいファイルを作成（例: news.js）
// 2. ここに import と registry への登録を追加
import defaults from './default';
import homeOverrides from './home';

const registry = {
  partners: 'none',
  specialcontents: 'none',
  partners: 'none',
  home: homeOverrides,
  // 例: 以下のように追加
  // news: newsOverrides,
  // exhibitors: exhibitorsOverrides,
};

/**
 * default のグループ配列にテンプレート固有の上書きをマージする
 * - グループ内の items を path で照合し、一致するものは上書き、不一致は追加
 * - グループの weight も上書き可能
 * - default にないインデックスのグループは新規追加
 */
function mergeAnimations(overrides) {
  if (!overrides.animations || overrides.animations.length === 0) {
    return defaults.animations;
  }

  const merged = defaults.animations.map(group => ({
    ...group,
    items: group.items.map(item => ({ ...item })),
  }));

  overrides.animations.forEach((overrideGroup, i) => {
    if (i < merged.length) {
      if (overrideGroup.weight !== undefined) {
        merged[i].weight = overrideGroup.weight;
      }
      if (overrideGroup.items) {
        for (const overrideItem of overrideGroup.items) {
          const idx = merged[i].items.findIndex(a => a.path === overrideItem.path);
          if (idx !== -1) {
            merged[i].items[idx] = { ...merged[i].items[idx], ...overrideItem };
          } else {
            merged[i].items.push({ ...overrideItem });
          }
        }
      }
    } else {
      merged.push({
        ...overrideGroup,
        items: overrideGroup.items ? overrideGroup.items.map(item => ({ ...item })) : [],
      });
    }
  });

  return merged;
}

/**
 * default の config にテンプレート固有の config をシャローマージする
 * 上書き側に項目がないものは default の値を使用
 */
function mergeConfig(overrides) {
  if (!overrides.config) {
    return { ...defaults.config };
  }
  return { ...defaults.config, ...overrides.config };
}

/**
 * body の class から template-{name} を読み取り、
 * default をベースにテンプレート固有の上書きをマージして返す
 * @returns {{ config: object, animations: Array }}
 */
export function getSettings() {
  const bodyClass = document.body.className || '';
  const match = bodyClass.match(/template-(\S+)/);
  const templateName = match ? match[1] : null;

  if (templateName && registry[templateName] !== undefined) {
    const overrides = registry[templateName];
    if (overrides === 'none') return null;
    return {
      config: mergeConfig(overrides),
      animations: mergeAnimations(overrides),
    };
  }
  return {
    config: { ...defaults.config },
    animations: defaults.animations,
  };
}
